import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  AddButton,
  Circle,
  CsvFile,
  FullTable,
  Line,
  MinLoader,
  PriceConvertor,
  PriceRow,
  ToastScreen,
} from 'components';
import {
  Colors, FindLoad,
  Images, isFactored, loadProfit,
  PermissionsList,
  RolePermission,
  SavePage,
  useGlobalStyles,
  useGlobalText,
  useModal,
} from 'utils';
import { CustomDeleteModal } from 'fragments';
import { transactionBody, transactionHead, ACTION_TYPE, transactionStyles, AddTransactionModal } from './core';
import { authService } from '../../../store/loads/loads.service';
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions, loadActions } from 'store';
import {
  CARRIER_TXNS_ACTION_TYPE,
  carrierTransactionHead,
  OTHER_TXNS_ACTION_TYPE, otherTransactionBody, otherTransactionHead,
  transactionCarrierBody, TxnType,
} from './core/constants';
import { CANCELLED } from '../../../pages/accounting/constants';
import { EditTransactionDescription } from './core/editTransactionDescription';
import { LoadService } from '../../factoredLoads/load.service';
import { toast } from 'react-toastify';
import { loadStatusEnum } from '../../../pages';

const VOID_TYPE = 'TRANSACTION_VOID';
const REVERSE_TYPE = 'TRANSACTION_REVERSE';

export const Transactions = ({ load }) => {
  const { loadTransactions, loadCarrierTxns, loadOtherTxns } = useSelector((state) => ({
    loadTransactions: state.loads.loadTransactions,
    loadCarrierTxns: state.loads.loadCarrierTxns,
    loadOtherTxns: state.loads.loadOtherTxns,
  }));
  const dispatch = useDispatch();
  const globalStyles = useGlobalStyles();
  const globalText = useGlobalText();
  const classes = transactionStyles();
  const checkLoadTxnsCreation =
    load?.status === 'PROCESSING' ? true :
     load?.status === loadStatusEnum.PENDING_FLOAT ? true :
      load?.status === 'INTRANSIT' ? true :
        load?.status === 'PENDING' ? true :
          load?.status === 'COMPLETED';

  const history = useHistory();
  const location = useLocation();
  const pushInfo = history?.location?.state;
  const { open, close } = useModal();
  const otherTransactions = loadOtherTxns?.txns?.filter((i) => i.onModel === 'OFFICE' || i.onModel === 'CORP');
  const loadReverse = FindLoad(REVERSE_TYPE);
  const checkReverse = loadCarrierTxns?.txns?.filter((i) => i.onModel === 'CARRIER' );
  const lpfCredit =  checkReverse?.filter((i) => i.type === "LPF_CARRIER_CREDIT");
  const lpfCharge = checkReverse?.filter((i) => i.type === "LPF_CARRIER_CHARGE");
  const lpfCreditTotal = lpfCredit?.reduce((sum, i) => sum + i.amount, 0);
  const lpfChargeTotal = lpfCharge?.reduce((sum, i) => sum + i.amount, 0);
  const vendorTxns = loadTransactions?.txns?.filter((i) => (i?.onModel === "CUSTOMER" && i?.type === TxnType.CUSTOMERPAYMENT) || i?.onModel === "CARRIER");

  useEffect(() => {
    const hasKey = Object.keys(TxnType).includes(pushInfo?.type);

    const txnsInfo = {
      ...pushInfo,
    };
    delete txnsInfo.loadParams;
    delete txnsInfo.carrierVoid;
    delete txnsInfo.carrierType;
    delete txnsInfo.activeTab;
    delete txnsInfo.page;
    delete txnsInfo.limit;
    delete txnsInfo.skip;
    delete txnsInfo.viewType;
    if(!hasKey){
      delete txnsInfo.type;
    }
    dispatch(loadActions.getLoadTransactions(load?.id, '', txnsInfo));

    const carrierTxnsInfo = {
      ...pushInfo,
    };
    delete carrierTxnsInfo.loadParams;
    delete carrierTxnsInfo.activeTab;
    delete carrierTxnsInfo.page;
    delete carrierTxnsInfo.limit;
    delete carrierTxnsInfo.skip;
    delete carrierTxnsInfo.viewType;

    if (pushInfo?.carrierType) {
      carrierTxnsInfo.type = pushInfo?.carrierType;
      delete carrierTxnsInfo.carrierType;

    } else {
      delete carrierTxnsInfo.type;
    }

    if (pushInfo?.carrierVoid) {
      carrierTxnsInfo.status = pushInfo?.carrierVoid;
      delete carrierTxnsInfo.carrierVoid;
    } else {
      delete carrierTxnsInfo.status;
    }
    dispatch(loadActions.getLoadCarrierTransactions(load?.id, '', carrierTxnsInfo));


    const otherTxnsInfo = {
      ...pushInfo,
    };
    delete otherTxnsInfo.loadParams;
    delete otherTxnsInfo.activeTab;
    delete otherTxnsInfo.page;
    delete otherTxnsInfo.limit;
    delete otherTxnsInfo.skip;
    delete otherTxnsInfo.viewType;

    if (pushInfo?.otherType) {
      otherTxnsInfo.type = pushInfo?.otherType;
      delete otherTxnsInfo.otherType;
    } else {
      delete otherTxnsInfo.type;
    }

    if (pushInfo?.otherVoid) {
      otherTxnsInfo.status = pushInfo?.otherVoid;
      delete otherTxnsInfo.otherVoid;
    } else {
      delete otherTxnsInfo.status;
    }

    dispatch(loadActions.getLoadOtherTransactions(load?.id, '', otherTxnsInfo));
  }, [pushInfo]);

  const handleOpenModal = (info) => {
    if (load?.status !== CANCELLED) {
      open(
        <CustomDeleteModal
          actionType={VOID_TYPE}
          type={'void'}
          text={'Void Transaction?'}
          handleDel={() => handleVoid(info)}
        />,
      );
    }
  };

  const handleVoid = async (info) => {
    dispatch(httpRequestsOnSuccessActions.removeSuccess(VOID_TYPE));
    dispatch(httpRequestsOnLoadActions.appendLoading(VOID_TYPE));
    try {
      await authService.editLoadTransactionsService(info?.load, info?.id);
      dispatch(loadActions.getLoadById(info?.load, 'noLoad'));
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(VOID_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(VOID_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    } catch (e) {
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(VOID_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    }
  };

  const handleReverse = async ( ) => {
    dispatch(httpRequestsOnSuccessActions.removeSuccess(REVERSE_TYPE));
    dispatch(httpRequestsOnLoadActions.appendLoading(REVERSE_TYPE));
    try {
      await authService.reverseTransactionService(load?.id);
      toast(<ToastScreen type={'success'} text='LPF was Reversed' />);
      dispatch(loadActions.getLoadById(load?.id, 'noLoad'));
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(REVERSE_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(REVERSE_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    } catch (e) {
      toast(<ToastScreen type={'error'} text={e?.data?.message} />);
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(REVERSE_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    }
  };

  const editDesc = (info) => {
    open(<EditTransactionDescription info={info} />);
  };

  return (
    <div>
      <div>
        <div className={classes.addSection} style={{ gap: 16, alignItems: 'center' }}>
          {RolePermission([PermissionsList.ALL_ACCESS?.code]) &&
            <CsvFile params={{ type: 'txns', loadId: load?.id, noModal: true }} />
          }

          {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.ADD_TRANSACTION?.code], 'agentView') && checkLoadTxnsCreation &&
            <AddButton
              handleClick={() => open(<AddTransactionModal info={load} isFactored={load?.isFactored} />)}
              text={'Add Transaction'}
            />
          }
        </div>
        <div className={globalStyles.centerItem}>
          <div className="full-width">
            <div className={globalStyles.flexAble}>
              <Circle number={1} back={Colors.ThemeAqua} />
              <p className={globalText.title}>Totals</p>
            </div>
            <div className={classes.lineAndTable}>
              <Line height={'auto'} />

              <div className="flex-column" style={{ gap: 16, padding: '16px 0 32px', width: '100%' }}>

                {!load?.isFactored &&
                  <div className="transaction-box"
                       style={{ background: 'rgba(67, 138, 254, 0.10)', maxWidth: '200px' }}>
                    <p className="transaction-box-title">Load Profit</p>
                    <p className="transaction-box-desc">Total</p>
                    <PriceConvertor price={loadProfit(load)} />
                  </div>
                }


                <div className="transaction-box" style={{ background: 'rgba(236, 199, 17, 0.15)' }}>
                  <p className="transaction-box-title">Customer Total</p>
                  <div className="flex-align-start" style={{ gap: 16 }}>
                    <div className="transaction-info-box" style={{ borderColor: '#FFE568' }}>
                      <p className="transaction-box-desc">Rate Total</p>
                      <PriceConvertor price={load?.bill?.totalRate} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#FFE568' }}>
                      <p className="transaction-box-desc">Paid Total</p>
                      <PriceConvertor price={load?.customerPaid} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#FFE568' }}>
                      <p className="transaction-box-desc">Corporate</p>
                      <PriceConvertor price={load?.bill?.corporateCharges} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#FFE568' }}>
                      <p className="transaction-box-desc">Prepay</p>
                      <PriceConvertor price={load?.bill?.prepay} />
                    </div>
                    <div className="transaction-info-box" style={{ border: 'none' }}>
                      <p className="transaction-box-desc">Balance</p>
                      <PriceConvertor price={LoadService.getBillBalance(load?.bill)} />
                    </div>
                  </div>
                </div>

                <div className="transaction-box" style={{ background: 'rgba(0, 200, 81, 0.10)' }}>
                  <p className="transaction-box-title">Vendor Total</p>
                  <div className="flex-align-start" style={{ gap: 16 }}>
                    <div className="transaction-info-box" style={{ borderColor: '#00C851' }}>
                      <p className="transaction-box-desc">Rate Total</p>
                      <PriceConvertor price={load?.carrierRate} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#00C851' }}>
                      <p className="transaction-box-desc">Carrier Charges</p>
                      <PriceRow info={load?.carrierCharges} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#00C851' }}>
                      <p className="transaction-box-desc">Paid Total</p>
                      <PriceConvertor price={load?.carrierPaid} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#00C851' }}>
                      <p className="transaction-box-desc">Corporate</p>
                      <PriceConvertor price={load?.payable?.corporateCharges} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#00C851' }}>
                      <p className="transaction-box-desc">Collections</p>
                      <PriceConvertor price={load?.payable?.collections} />
                    </div>
                    <div className="transaction-info-box" style={{ borderColor: '#00C851' }}>
                      <p className="transaction-box-desc">Reserved</p>
                      <PriceConvertor price={load?.payable?.carrierReserve?.keptAmount || 0} />
                    </div>
                    <div className="transaction-info-box" style={{ border: 'none' }}>
                      <p className="transaction-box-desc">Balance</p>
                      <PriceConvertor price={LoadService.getPayableBalance(load?.payable)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {!load?.isFactored &&
          <>
            <div className={globalStyles.centerItem}>
              <div className={globalStyles.spaceBetween}>
                <div className={globalStyles.flexAble}>
                  <Circle number={2} back={Colors.ThemeAqua} />
                  <p className={globalText.title}>Customer Transactions</p>
                </div>
              </div>
            </div>
            <div className={classes.lineAndTable}>
              <Line height={'auto'} />
              <FullTable
                height={'medium'}
                head={transactionHead}
                body={transactionBody()}
                loadingType={ACTION_TYPE}
                list={loadTransactions?.txns?.filter((i) => i.onModel === 'CUSTOMER')}
                noText={'Customer Transaction'}
                // handleClickButton={handleOpenModal}
              />
            </div>
          </>
        }
      </div>
      <div style={{ marginTop: '50px' }}>
        <div className={globalStyles.centerItem}>
          <div className={globalStyles.spaceBetween}>
            <div className={globalStyles.flexAble}>
              <Circle number={load?.isFactored ? 2 : 3} back={Colors.ThemeAqua} />
              <p className={globalText.title}>Transactions</p>
            </div>
            {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.ADD_TRANSACTION?.code], 'agentView') && checkLoadTxnsCreation &&
              (lpfCreditTotal - lpfChargeTotal) !== 0 && !load?.isFactored &&
              <button
                onClick={handleReverse}
                className={classes?.reverseLpf}
                disabled={!!loadReverse?.length}
              >
                {loadReverse?.length ?
                  <MinLoader margin={'0'} color={Colors.ThemeGreen} position={'relative'} style={{width: 20, height: 20}}  />
                  :
                  <img src={Images.undo} alt="undo" />
                }
                <p>Reverse LPF</p>
              </button>
            }
          </div>
        </div>
        <div className={classes.lineAndTable}>
          <Line height={'auto'} />
          <FullTable
            height={'medium'}
            head={carrierTransactionHead}
            body={transactionCarrierBody()}
            loadingType={CARRIER_TXNS_ACTION_TYPE}
            list={load?.isFactored ? vendorTxns : loadTransactions?.txns?.filter((i) =>  i?.onModel === "CARRIER")  }
            noText={'Carrier Transaction'}
          />
        </div>
      </div>


      {otherTransactions?.length ?
        <div style={{ marginTop: '50px' }}>
          <div className={globalStyles.centerItem}>
            <div className={globalStyles.spaceBetween}>
              <div className={globalStyles.flexAble}>
                <Circle number={4} back={Colors.ThemeAqua} />
                <p className={globalText.title}>Other Transactions</p>
              </div>
            </div>
          </div>
          <div style={{ width: 'auto' }} className="info-table-no-line">
            <FullTable
              height={'medium'}
              head={otherTransactionHead}
              body={otherTransactionBody(editDesc)}
              loadingType={OTHER_TXNS_ACTION_TYPE}
              list={loadOtherTxns?.txns?.filter((i) => i.onModel === 'OFFICE' || i.onModel === 'CORP')}
              noText={'Other Transaction'}
              handleClickButton={handleOpenModal}
            />
          </div>
        </div>
        :
        ''
      }
    </div>
  );
};